module.exports = __webpack_public_path__ + "img/setupbamfriction-min.e391b5fb.jpg";